import React, { useState } from "react";

const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;

const AgentForm = ({ agent, onClose, onSaved }) => {
  const [form, setForm] = useState(
    agent || { name: "", description: "", system_prompt: "", config: {} }
  );

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const handleSubmit = async () => {
    const url = agent?.id
      ? `${apiBaseURL}/agents/${agent.id}`
      : `${apiBaseURL}/agents`;
    const method = agent?.id ? "PUT" : "POST";

    await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });
    onSaved();
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-[500px] space-y-4 border border-gray-200">
        <h2 className="text-xl font-semibold text-gray-800">
          {agent ? "Edit Agent" : "Create Agent"}
        </h2>

        <input
          className="border border-gray-300 rounded-md p-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          placeholder="Name"
          value={form.name}
          onChange={(e) => handleChange("name", e.target.value)}
        />

        <textarea
          className="border border-gray-300 rounded-md p-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          placeholder="Description"
          value={form.description}
          onChange={(e) => handleChange("description", e.target.value)}
          rows={3}
        />

        <textarea
          className="border border-gray-300 rounded-md p-2 w-full text-sm font-mono focus:outline-none focus:ring-2 focus:ring-teal-500"
          placeholder="System Prompt"
          value={form.system_prompt}
          onChange={(e) => handleChange("system_prompt", e.target.value)}
          rows={6}
        />

        <textarea
          className="border border-gray-300 rounded-md p-2 w-full text-sm font-mono focus:outline-none focus:ring-2 focus:ring-teal-500"
          placeholder="Config (JSON)"
          value={JSON.stringify(form.config || {}, null, 2)}
          onChange={(e) => {
            try {
              handleChange("config", JSON.parse(e.target.value));
            } catch {
              // ignore invalid JSON while typing
            }
          }}
          rows={4}
        />

        <div className="flex justify-end space-x-2">
          <button
            className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded-md text-sm"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="bg-teal-600 hover:bg-teal-700 text-white px-4 py-2 rounded-md text-sm"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgentForm;
